export const OH_NOTE_MSG_TYPE = 'oral-hygiene-recommendation'

export const Categories = {
  BrushingTechnique: 'brushing_techniques',
  DentalHygienist: 'dental_hygienist',
  SoftBrushing: 'soft_brushing',
  Periodontist: 'periodontist',
  InterdentalAccessories: 'interdental_accessories'
}
